import { useEffect } from 'react'

import Loading from '@/components/loading'
import { MessageModal } from '@/components/message-modal'
import { useConfirmUser } from '@/hooks/queries/use-confirm-user'
import { GET_COMPANIES_BY_USER_QUERY } from '@/hooks/queries/use-get-companies'
import { queryClient } from '@/services/query-client'

import { Confirmed } from './confirmed'

interface CompanyProps {
  token: string
}

export function Company({ token }: CompanyProps) {
  const { isError, isFetching, isSuccess } = useConfirmUser(
    token,
    'confirmCompany',
  )

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries([GET_COMPANIES_BY_USER_QUERY])
    }
  }, [isSuccess])

  if (isFetching) {
    return <Loading />
  }

  if (isError) {
    return (
      <MessageModal
        title='Erro'
        message='Ocorreu um erro ao vincular o usuário à companhia.'
        type='error'
      />
    )
  }

  return <Confirmed />
}
